const post = (WpTag = '') => `
  id
  language {
    code
  }
  seo {
    opengraphTitle
    canonical
    metaDesc
    metaKeywords
    opengraphDescription
    opengraphImage {
      srcSet
      sourceUrl
    }
    opengraphSiteName
    opengraphUrl
    schema {
      raw
      pageType
      articleType
    }
    title
    twitterDescription
    twitterImage {
      srcSet
      sourceUrl
      uri
      title
    }
    twitterTitle
    readingTime
    opengraphType
    opengraphPublishedTime
    opengraphModifiedTime
    opengraphPublisher
  }
  blog {
    itemSubtitle
    similar {
      ... on ${WpTag}Post {
        id
        blog {
          banner {
            sourceUrl
          }
        }
        title
        dateGmt
        uri
      }
    }
    textContent
    banner {
      title
      sourceUrl
    }
  }
  categories {
    nodes {
      name
      slug
    }
  }
  tags {
    nodes {
      name
      slug
    }
  }
  dateGmt
  date
  link
  seo {
    metaDesc
    fullHead
  }
  slug
  title
  uri
  author {
    node {
      username
      seo {
        title
      }
      nickname
      nicename
      name
      firstName
      lastName
      description
      avatar {
        url
      }
    }
  }
`;

module.exports.post = post;
